import { GzzTelephone } from "../general/GzzTelephone";
import { GzzAddress } from "../general/GzzAddress";
import { GzzBankAccount } from "../general/GzzBankAccount";

export class ClmClaimer {
    //Claimer details
    FirstName: string;
    LastName: string;
    IDNumber: string;
    DateOfBirth: Date;
    Gender: boolean;
    DateOfImmigratio: Date;
    FamilyStatus: number;
    WifeName: string;
    WifeIDNumber: string;
    //Additional info
    BirthCountry: number;
    DateOfImmigration: number;
    FathersName: string;
    FatherBirthCountry: string;
    FatherPrevFirstName: string;
    FatherPrevLastName: string;
    Address: GzzAddress;
    //Contact Info
    PhoneNumber: GzzTelephone;
    MobileNumber: GzzTelephone;
    FaxNumber: GzzTelephone;
    AgreeReceiveSMS: boolean;
    Email: string;
    //Another contact
    ContanctCloserToCaimer: string;
    ContanctFirstName: string;
    ContanctLastName: string;
    ContanctPhoneNumber: GzzTelephone;
    ContanctMobileNumber: GzzTelephone;
    BankAccountDetails: GzzBankAccount;

    constructor(data: ClmClaimer) {

      Object.assign(this, data);


      if (data) {

        if (data.PhoneNumber) {
          this.PhoneNumber = new GzzTelephone(data.PhoneNumber);
        }
        if (data.MobileNumber) {
          this.MobileNumber = new GzzTelephone(data.MobileNumber);
        }
        if (data.FaxNumber) {
          this.FaxNumber = new GzzTelephone(data.FaxNumber);
        }
        if (data.Address) {
          this.Address = new GzzAddress(data.Address);
        }
        if (data.ContanctPhoneNumber) {
          this.ContanctPhoneNumber = new GzzTelephone(data.ContanctPhoneNumber);
        }
        if (data.ContanctMobileNumber) {
          this.ContanctMobileNumber = new GzzTelephone(data.ContanctMobileNumber);
        }
        if (data.BankAccountDetails) {
          this.BankAccountDetails = new GzzBankAccount(data.BankAccountDetails);
        }
      }
    }
}



// WEBPACK FOOTER //
// E:/Develop/MOH.Gazezet/Dev/MOH.Gazzezet/MOH.Gazzezet/src/app/models/claim/ClmClaimer.ts